import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./email-service.css";
import { Link } from 'react-router-dom';

import Arrow from "../../../assets/images/Services/right-arrow.png"


import img1 from "../../../assets/images/Services/Email/email-services-img-1.jpg"; // left image
import img2 from "../../../assets/images/Services/Email/email-services-img-2.jpg"; // right image

import SEO from '../../seo';

export default function EmailService() {
     const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];
    return (
        <div>
               <SEO
                title="Email Services | Horizon WebInfo Pvt Ltd"
                description="Business Email Experience professional communication with our Business Email service. Tailored for small to medium-sized enterprises, our Business Email offers: Custom email addresses (you@yourcompany.com) Ad-free and secure email hosting Synchronized access across devices Robust spam and virus protection Enterprise Email For larger organizations with advanced collaboration needs, our Enterprise Email is the ideal solution. Enjoy [&hellip;]"
                canonical="https://www.hwplindia.com/service/email-services/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/email-services-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Email Services</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                         <li><Link to="/services">Services</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Email Services</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section">
                <div className="branding-container">
                    {/* Images Section */}
                    <div className="branding-images">
                        <img src={img1} alt="branding" className="branding-img" />
                        <img src={img2} alt="branding" className="branding-img" />
                    </div>

                    {/* Content Section */}
                    <div className="branding-content">
                        {/* CTA */}
                        <section className="cta-section">
                            <h3 className='underline-red'>Business Email</h3>
                            <p className='email'>
                                Experience professional communication with our Business Email service. Tailored for small to medium-sized enterprises, our Business Email offers:
                            </p>
                            {/* Why Choose Us */}
                            <section className="email-service">
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Custom email addresses (you@yourcompany.com)</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Ad-free and secure email hosting</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Synchronized access across devices</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Robust spam and virus protection</li>

                                </ul>
                            </section>
                        </section>
                        {/* CTA */}
                        <section className="cta-section">
                            <h3 className='underline-red'>Enterprise Email</h3>
                            <p className='email'>
                                For larger organizations with advanced collaboration needs, our Enterprise Email is the ideal solution. Enjoy the benefits of:
                            </p>
                            {/* Why Choose Us */}
                            <section className="email-service">
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Collaborative tools for teams</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Shared calendars and contacts</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Enhanced security features</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Advanced admin controls for centralized management</li>

                                </ul>
                            </section>
                        </section>
                        {/* CTA */}
                        <section className="cta-section">
                            <h3 className='underline-red'>Office 365</h3>
                            <p className='email'>
                                Empower your team with the industry-leading Office 365 suite. Unlock a world of productivity with:
                            </p>
                            {/* Why Choose Us */}
                            <section className="email-service">
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Microsoft Office applications (Word, Excel, PowerPoint, Outlook)
                                    </li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Cloud storage with OneDrive</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Real-time collaboration with Microsoft Teams</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Regular updates and feature enhancements</li>

                                </ul>
                            </section>
                        </section>
                        {/* CTA */}
                        <section className="cta-section">
                            <h3 className='underline-red'>Google Workplace</h3>
                            <p className='email'>
                                Drive collaboration and innovation with Google Workplace. Take advantage of:
                            </p>
                            {/* Why Choose Us */}
                            <section className="email-service">
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Gmail for Business with your domain</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Google Drive for secure cloud storage</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Google Meet for seamless video conferencing</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Shared calendars and collaborative document editing</li>

                                </ul>
                            </section>
                        </section>

                        <section className='domain-p email-p'>
                            <h3 className='underline-red email-h3'>Why Choose Our Email Services?</h3>
                            <p><span>Reliability: </span> Our services guarantee high uptime and reliability.</p>
                            <p><span>Security:  </span> Robust measures to safeguard your data and communications.</p>
                            <p><span>Scalability: </span> Grow seamlessly with scalable plans tailored to your needs.</p>
                            <p><span>Expert Support: </span> Access expert support when you need it.</p>
                        </section>

                        {/* CTA */}
                        <section className="cta-section">
                            <h3>Let's Build Your Digital Empire Together!</h3>
                            <p>
                                Whether you are a startup, a growing business, or an established enterprise, our Email Services are designed to scale with you. Elevate your communication infrastructure and streamline collaboration with our tailored solutions. <br />
                                Ready to enhance your email experience? Contact us today at info@hwplindia.com or +91 98988 76310 to discuss your specific requirements and discover how our Email Services can transform the way you do business.
                            </p>
                            <Link to="/get-a-quote" className="quote-btn1-brand">
                                <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                            </Link>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}